// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3sJJM","filesListContainer":"PosDisputesFiles_filesListContainer__1CMaI","filesButton":"PosDisputesFiles_filesButton__XjnOU"};